import { jsx as i } from "react/jsx-runtime";
import { useRef as m, useState as p, useEffect as h } from "react";
import a from "../LoadingIndicator/index.js";
import l from "../Button/index.js";
const z = ({ children: s, style: r, icon: c, isLoading: e = !1, ...u }, t) => {
  t = m(t);
  const [d, f] = p(0);
  return h(() => {
    if (!t)
      return;
    const { current: o } = t;
    if (!o)
      return;
    const n = new ResizeObserver(() => {
      f(o.offsetWidth);
    });
    return n.observe(o), () => {
      n.disconnect();
    };
  }, [t]), /* @__PURE__ */ i(
    l,
    {
      ...u,
      style: e ? { width: d + "px", pointerEvents: "none", ...r } : r,
      icon: e ? /* @__PURE__ */ i(a, { color: "inherit", size: "100%" }) : c,
      ref: t,
      children: !e && s
    }
  );
};
export {
  z as default
};
